import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";

@Component({
  selector: "app-input-password",
  standalone: true,
  imports: [CommonModule, InputTextModule, ReactiveFormsModule, FormsModule, PasswordModule],
  templateUrl: "./input-password.component.html",
})
export class InputPasswordComponent {
  @Input() form: FormGroup | null = null;
  @Input() name = "";
  @Input() label = "";
  @Input() styleClass = "";
  @Input() widthClass = "w-full";
  @Input() labelClass = "";
  @Input() errors = "";
  @Input() required = false;
  @Input() direction: "row" | "col" = "col";
}
